import { render, staticRenderFns } from "./user-and-company-card.vue?vue&type=template&id=635b789c&scoped=true"
import script from "./user-and-company-card.vue?vue&type=script&lang=js"
export * from "./user-and-company-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b789c",
  null
  
)

export default component.exports